import { c as _c } from "react/compiler-runtime";
import { CornerUpLeft, MessageSquareQuote } from 'lucide-react';
import type { CicloPendenciaParsed } from '@/shared/utils/descricaoCiclosPendencia';

/**
 * Caixinha cinza por pendência resolvida, no MESMO grafismo visual que a aba Pendências já usa
 * (`RastroPendencia.tsx`: rótulo pequeno em maiúsculas + texto em itálico) — só aplicado aqui ao
 * andamento composto que a Secretaria resolve/responde em lote (ClickUp: paridade de layout,
 * 02/09/2026). Puramente visual: não adiciona nem esconde nenhuma informação que
 * `andamento.descricao` já não carregasse em prosa.
 */
export function CiclosPendenciaAndamento(t0) {
  const $ = _c(4);
  const {
    ciclos
  } = t0;
  let t1;
  if ($[0] !== ciclos) {
    t1 = ciclos.map(_temp);
    $[0] = ciclos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div data-dd-privacy="mask" className="mt-2 flex flex-col gap-2.5">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(ciclo, indice) {
  return <div key={`${indice}-${ciclo.titulo}`} className="flex flex-col gap-2.5 rounded-[8px] bg-neutral-50 p-3"><span className="text-default-font text-sm">Pendência: <span className="font-semibold">"{ciclo.titulo}"</span> ({ciclo.destinatario}).</span>{ciclo.origem && <div className="border-l-2 border-neutral-200 pl-3"><span className="text-subtext-color inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wide uppercase"><MessageSquareQuote size={12} />Andamento de origem</span>{ciclo.origem.texto ? <p className="text-default-font mt-1 text-sm leading-snug italic">"{ciclo.origem.texto}"</p> : null}<div className="text-subtext-color mt-1 text-[11px]">Evento {ciclo.origem.eventoNumero}</div></div>}{ciclo.resposta && <div className="border-l-2 border-neutral-200 pl-3"><span className="text-subtext-color inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wide uppercase"><CornerUpLeft size={12} />{ciclo.resposta.autor ? `Resposta de ${ciclo.resposta.autor}` : "Resposta"}</span><div className="text-subtext-color mt-1 text-[11px]">Evento {ciclo.resposta.eventoNumero}</div></div>}</div>;
}